import { memo } from 'react';
import { useLocation } from 'react-router-dom';
import { dateToString } from '@/utils';
import { useGetParentEventsQuery } from '@/services/parent-api';
import Table from '@/components/table';

const columns = [
  {
    title: 'Event',
    dataIndex: 'event',
    render: (value) => <a href={`/events/${value.eventId}/view`}>{value.name}</a>,
  },
  {
    title: 'Date',
    key: 'date',
    render: (_, record) => dateToString(record.event.eventDate.date),
  },
  {
    title: 'Type',
    key: 'type',
    render: (_, record) => record.event.type.name,
  },
  {
    title: 'Hosted',
    key: 'host',
    render: (_, record) => record.event.host.name,
  },
];

const Events = ({ parentId }) => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const pageNumber = queryParams.get('page') || 1;
  const { data, isFetching } = useGetParentEventsQuery({ parentId, pageNumber });

  return (
    <Table
      columns={columns}
      dataSource={data?.data}
      rowKey="attendId"
      loading={isFetching}
      pageInfo={data}
      size="small"
    />
  );
};

export default memo(Events);
